import { render, staticRenderFns } from "./RelatoriosCarrinho.vue?vue&type=template&id=a04d3264&scoped=true"
import script from "./RelatoriosCarrinho.vue?vue&type=script&lang=js"
export * from "./RelatoriosCarrinho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04d3264",
  null
  
)

export default component.exports